import { render, staticRenderFns } from "./CreateCompanyLicenseForm.vue?vue&type=template&id=2fc5cff4&"
import script from "./CreateCompanyLicenseForm.vue?vue&type=script&lang=ts&"
export * from "./CreateCompanyLicenseForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCompanyLicenseForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports